import './App.css';
import { ProgressBarComponent } from 'react-progress-components'; 
import React, { useState, useEffect } from 'react';

const App = () => {
  const [ progress, setProgress ] = useState(5);

  useEffect(() => {
    if (progress >= 0 && progress < 100) {
      setTimeout(() => {
        setProgress(progress + 5);
      }, 125);
    };
  });

  return (
    <div className="App">
      <p style={{ margin: '20px', color: 'white' }}>Progress bar type 'line' with text transparent</p>
      <ProgressBarComponent type={ 'line' } method={ 'manual' } trackColor={ '#ddd' } shape={ 'round' } progressColor={ 'red' } textFont={ 'Arial' } textColor={ 'transparent' } size={ 1000 } progress={ progress } />
      <div className='content'>
        <div className='card'>
          <p>Card 1: Progress bar type 'circle'</p>
          <ProgressBarComponent type={ 'circle' } method={ 'manual' } trackColor={ '#ddd' } progressColor={ '#00FFD1' } textFont={ 'Arial' } size={ 200 } progress={ progress } />
        </div>

        <div className='card'>
          <p>Card 2: Progress bar type 'line' with text 'darkGreen'</p>
          <ProgressBarComponent type={ 'line' } method={ 'manual' } trackColor={ '#ddd' } progressColor={ '#00FFD1' } textFont={ 'Arial' } textColor={ 'darkGreen' } size={ 500 } progress={ progress } />
        </div>

        <div className='card'>
          <p>Card 3: Progress bar type 'line' with text 'darkGreen' and shape 'square'</p>
          <ProgressBarComponent type={ 'line' } method={ 'manual' } trackColor={ '#ddd' } shape={ 'square' } progressColor={ '#00FFD1' } textFont={ 'Arial' } textColor={ 'darkGreen' } size={ 500 } progress={ progress } />
        </div>
      </div>
    </div>
  );
};

export default App;
